import db from '@/plugins/dexie';
import { ORIGEM_TIPO } from '@/constants/CHECKLIST';

// Reexportado por compatibilidade.
export { ORIGEM_TIPO };

function situacaoEnvio(envio) {
  if (!envio) return null;
  if (envio.fenconflito) return 'conflito';
  if (envio.fenfalhapermanente) return 'falha';
  if (envio.fenpayload?.concluir) return 'finalizado-pendente';
  return 'pendente';
}

export default {
  namespaced: true,

  actions: {
    // Fila lida do Dexie (mantida pelo delta).
    async find(_, { createdFrom, createdBefore, movimento } = {}) {
      const formularios = await db.formulario.toArray();

      const envios = await db.formularioenvio.toArray();
      const envioPorFormulario = envios
        .filter((envio) => !envio.fendatanuvem)
        .sort((a, b) => new Date(a.fendatagravacao) - new Date(b.fendatagravacao))
        .reduce((mapa, envio) => ({ ...mapa, [envio.fenidformulario]: envio }), {});

      const identificacoes = await db.formularioidentificacao.toArray();
      const identPorFormulario = identificacoes
        .reduce((mapa, ident) => ({ ...mapa, [ident.foridformulario]: ident }), {});

      return formularios
        .filter((formulario) => {
          // fordatacadastro é varchar: recorte por dia.
          const dia = String(formulario.fordatacadastro ?? '').substring(0, 10);
          if (createdFrom && dia && dia < createdFrom) return false;
          if (createdBefore && dia && dia > createdBefore) return false;

          if (movimento) {
            const situacao = formulario.fororigemdados?.card?.situacao;
            if (situacao !== movimento) return false;
          }

          return true;
        })
        .map((formulario) => {
          const envio = envioPorFormulario[formulario.foridnuvem] ?? null;
          const identificacao = identPorFormulario[formulario.foridnuvem] ?? null;

          return {
            ...formulario,
            // Mesmo formato de GET formulario/fila.
            id: formulario.foridnuvem,
            foiultimagravacao: envio?.fendatagravacao ?? identificacao?.foiultimagravacao ?? null,
            foinome: identificacao?.foinome ?? null,
            envioSituacao: situacaoEnvio(envio),
            envioErro: envio?.fenerro ?? null,
            envioTentativas: envio?.fententativas ?? 0,
          };
        });
    },
  },
};
